var React = require('react');

function ArrowRightBlog (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 12h14M12 5l7 7-7 7","stroke":"#9CA3AF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRightBlog.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = ArrowRightBlog;

ArrowRightBlog.default = ArrowRightBlog;
